import { Replay } from "neo-games";

export import ReplayService = Replay.ReplayService;
export import ReplayController = Replay.ReplayController;
export import ReplaySpbSimulation = Replay.ReplaySpbSimulation;
export import ReplayOverlay = Replay.ReplayOverlay;
export import ReplayGameClient = Replay.ReplayGameClient;

export type IReplayHost = Replay.IReplayHost;
export type IReplayHostCore = Replay.IReplayHostCore;
export type IReplaySpbSimulationHook = Replay.IReplaySpbSimulationHook;




/** WEBPACK FOOTER **
 ** ./Engine/Game/Replay.ts
 **/